import { PropsWithChildren } from 'react';
import styles from './PageContainer.module.scss';
import { PageHeader } from '../pageHeader';

interface PageContainerProps {
  searchComponent?: React.ReactNode;
}

export function PageContainer(props: PropsWithChildren<PageContainerProps>): React.ReactElement {
  return (
    <div className={styles.pageContainer}>
      <PageHeader searchComponent={props.searchComponent} />
      {props.children}
    </div>
  );
}
